import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { streamPlaceHighlights } from 'tripPlanner/api'
import { useTextStream } from './useTextStream'

interface UseStreamPlaceHighlightsResult {
  markdown: string
  isStreaming: boolean
  isLoading: boolean
  isError: boolean
  retry: () => void
}

export function useStreamPlaceHighlights(
  googlePlaceId: string | undefined,
  enabled = true,
): UseStreamPlaceHighlightsResult {
  const locale = useAppSelector(state => state.geo.locale)

  const cacheKey = useMemo(
    () => ['placeHighlights', googlePlaceId ?? '', locale ?? ''],
    [googlePlaceId, locale],
  )

  const createStream = useMemo(() => {
    if (!enabled || !googlePlaceId) return undefined
    return () => (onChunk: (chunk: string) => void, signal: AbortSignal) =>
      streamPlaceHighlights(googlePlaceId, undefined, onChunk, signal, locale)
  }, [enabled, googlePlaceId, locale])

  const { content, isStreaming, isLoading, isError, retry } = useTextStream(cacheKey, createStream)

  return { markdown: content, isStreaming, isLoading, isError, retry }
}
